export default function () {
  return this._imageWidth - this._scaledRotatedInternalImageWidth
}
